import React from "react";

import Entities from "../../components/Entities";

function Products() {
  return (
    <Entities
      shema={{
        searchFromServer: true,
        searchRoute: "products",
        fields: [
          {
            name: "Principal",
            propertyName: "manufacturer",
            isObject: true,
            search: true,
          },
          {
            name: "Brand",
            propertyName: "make",
            search: true,
          },
          {
            name: "Description",
            propertyName: "description",
            search: true,
          },
          {
            name: "UPC Code",
            propertyName: "upcCode",
            search: true,
          },
          {
            name: "Size",
            propertyName: ["formatQut", "format"],
          },
          {
            name: "Product Type",
            propertyName: "productType",
            isObject: true,
            filter: true,
            filterRoute: "product_types",
          },
        ],
      }}
    />
  );
}

export default Products;
